import { ModalInstance } from "@js/components/modal";

import type { RejectOfferMessageWrapperProps } from "../../models";

import { RejectOfferMessageWrapper } from "./reject-offer-message-wrapper";

import style from "./style.module.scss";

export const openRejectOfferMessageModal = ({
  nextUrl,
  refetchBidList,
  bids,
  job,
}: RejectOfferMessageWrapperProps) => {
  ModalInstance.open({
    className: style.makeOfferMessageModal,
    keepOnBackdropClick: true,
    children: (
      <RejectOfferMessageWrapper
        bids={bids}
        refetchBidList={refetchBidList}
        nextUrl={nextUrl}
        job={job}
      />
    ),
    padding: false,
    closeButton: true,
    closeButtonProps: {
      style: {
        marginRight: "-8px",
        top: 0,
        right: "12px",
        padding: "16px",
      },
    },
  });
};
